import { JetView } from "webix-jet";
import { dateCommonFormat, dateFromISO } from "../../helpers/dateFormat";

export default class AuditView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.Type = "login";

		const form = {
			view: "form",
			rows: [
				{
					rows: [
						{
							view: "template",
							localId: "title",
							borderless: true,
							height: 30,
							css: "webix_um_details_title",
							template: "#name#",
							data: { name: "" },
						},
						{
							view: "radio",
							localId: "type",
							value: this.Type,
							options: [
								{ id: "login", value: _("logins") },
								{ id: "user", value: _("changes to") },
								{ id: "by-user", value: _("changes by") },
							],
							on: {
								onChange: t => this.ShowLogTable(t),
							},
						},
					],
				},
			],
		};

		this.InitColumns(_);
		const table = {
			view: "datatable",
			localId: "audit",
			rowHeight: Math.max(webix.skin.$active.rowHeight, 34),
			columns: this.GetColumns("login"),
			on: {
				onItemClick: id => this.ShowTarget(id),
			},
		};

		return {
			type: "clean",
			rows: [
				{
					rows: [form, table],
				},
			],
		};
	}

	init() {}

	urlChange() {
		this.$$("type").setValue(this.Type);
		this.ID = this.getParam("id", true);
		if (this.ID) {
			const local = this.app.getService("local");
			Promise.all([local.users(), local.roles(), local.logsMeta()]).then(
				data => {
					const user = data[0].getItem(this.ID);
					this.$$("title").setValues(user);
					this.ShowLogTable(this.Type);
				}
			);
		}
	}

	InitColumns(_) {
		const local = this.app.getService("local");

		const date = {
			id: "date",
			header: _("When"),
			fillspace: true,
			format: value => dateCommonFormat(dateFromISO(value)),
		};
		const user_id = {
			id: "user_id",
			header: _("Who"),
			fillspace: true,
			template: obj => {
				const user = local.users(true).getItem(obj["user_id"]);
				return user
					? `<span class="webix_um_cell_clickable">${user.name}</span>`
					: `<span class="webix_um_deleted_user"> ${_("Deleted")}</span>`;
			},
		};

		const target_id = {
			id: "target_id",
			header: _("Target"),
			fillspace: true,
			template: obj => {
				const target = this.GetTarget(obj).item;
				return target
					? `<span class="webix_um_cell_clickable">${target.name}</span>`
					: `<span class="webix_um_deleted_user"> ${_("Deleted")}</span>`;
			},
		};
		const type = {
			id: "type",
			header: _("Operation"),
			template: obj => {
				const type = local.logsMeta(true)[obj.type];
				return type ? type.name : obj.type;
			},
			fillspace: true,
		};

		const details = {
			id: "details",
			fillspace: true,
			header: _("Details"),
		};

		this.ColumnBatches = {
			login: [date, details],
			user: [date, user_id, type, details],
			"by-user": [date, target_id, type, details],
		};
	}

	ShowLogTable(type) {
		const logs = this.app.getService("backend").logs(type, this.ID);
		const table = this.$$("audit");
		// clearAll should be called before refreshing
		table.clearAll();
		table.refreshColumns(this.GetColumns(type));
		logs.then(data => {
			table.parse(data);
		});
	}

	GetColumns(type) {
		return webix.copy(this.ColumnBatches[type]);
	}

	ShowTarget(id) {
		const column = id.column;
		if (column == "target_id" || column == "user_id") {
			const item = this.$$("audit").getItem(id);
			let targetItem,
				type = "users";
			if (column == "target_id") {
				const target = this.GetTarget(item);
				targetItem = target.item;
				if (target.type == "role") type = "roles";
			} else
				targetItem = this.app
					.getService("local")
					.users(true)
					.getItem(item["user_id"]);
			if (targetItem)
				this.app.callEvent("details:item-click", [type, targetItem.id]);
		}
	}

	GetTarget(obj) {
		const local = this.app.getService("local");
		const type = local.logsMeta(true)[obj.type];
		const data =
			type && type.target == "role" ? local.roles(true) : local.users(true);
		return {
			item: data.getItem(obj["target_id"]),
			type: type ? type.target : "user",
		};
	}
}
